export default {
    signIn(email, password) {
        let dto = {
            Email: email,
            Password: password,
        };

        if (!email) {
            dto.Email = '';
        }

        if (!password) {
            dto.Password = '';
        }

        return DMUtils.http({
            method: 'POST',
            url: '/Auth/SignIn',
            data: dto,
        }).then((response) => {
            DMUtils.setAuthToken(response.AuthToken);
            return response;
        });
    },
    signInWithAuthToken(authToken) {
        DMUtils.setAuthToken(authToken);

        return DMUtils.http({
            method: 'POST',
            url: '/Auth/SignInWithAuthToken',
        })
            .then((response) => {
                return response;
            })
            .catch((error) => {
                DMUtils.clearAuthToken();

                return Promise.reject(error);
            });
    },
    signOut() {
        return DMUtils.http({
            method: 'POST',
            url: '/Auth/SignOut',
        }).then((response) => {
            DMUtils.clearAuthToken();
            return response;
        });
    },
    sendNewPassword(email) {
        return DMUtils.http({
            method: 'POST',
            url: '/Auth/ForgotPassword',
            data: { Email: email },
        });
    },
    resetPassword(dto) {
        return DMUtils.http({
            method: 'POST',
            url: '/Auth/ResetPassword',
            data: dto
        })
    },
    getPermissionsForUser() {
        return DMUtils.http({
            method: 'GET',
            url: '/Permission/GetAllForUser',
        });
    },
};
